import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";
const CosmosIconViewMoreStyle0 = cosmosIconCss;

const CosmosIconViewMore$1 = /*@__PURE__*/ proxyCustomElement(class CosmosIconViewMore extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.ariaLabel = undefined;
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: 'a0548b4b6aab6d91221cc78ad81b1974dc34cafc', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '8fe8538eecd06c19edf25fa33164dd734d2bd3d4', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: '97070ae30d85ce24a86a3f936c847f9f652764c7', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M11.022 4.001a1.52 1.52 0 0 1 0 3.04 1.466 1.466 0 0 1-1.52-1.52 1.466 1.466 0 0 1 1.52-1.52Zm0 5.48a1.52 1.52 0 1 1 0 3.04 1.52 1.52 0 0 1 0-3.04Zm1.52 6.999a1.52 1.52 0 1 0-3.041 0 1.52 1.52 0 0 0 3.04 0Z", fill: "currentColor" }))));
    }
    static get style() { return CosmosIconViewMoreStyle0; }
}, [1, "cosmos-icon-view-more", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-view-more"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-view-more":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconViewMore$1);
            }
            break;
    } });
}

const CosmosIconViewMore = CosmosIconViewMore$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosIconViewMore, defineCustomElement };
